import React from 'react';
import { useTranslation } from 'react-i18next';

import { ImageWrapper, OnboardingCreatorInfoBlock } from 'components';
import { OnboardingRegionForm } from 'containers/forms';

import { currencies } from 'constants/currenciesList';

import { PropTypes } from 'prop-types';
import { ReactComponent as Icon } from '../../assets/img/illustrations/region.svg';

const DEFAULT_CURRENCY = 'USD';

const defaultCurrency = currencies.find((currency) => currency.code === DEFAULT_CURRENCY);

const OnboardingRegionPage = ({ onNext, onLogout }) => {
  const { t } = useTranslation(['pages']);

  return (
    <>
      <h1 className="display-4 text-center">{t('onboarding.regionTitle')}</h1>
      <h4 className="text-muted text-center">{t('onboarding.regionSubtitle')}</h4>
      <ImageWrapper>
        <Icon />
      </ImageWrapper>
      <OnboardingCreatorInfoBlock onLogout={onLogout} />
      <OnboardingRegionForm
        initialValues={{
          base_currency: defaultCurrency.code,
        }}
        onNext={onNext}
      />
    </>
  );
};

OnboardingRegionPage.propTypes = {
  onNext: PropTypes.func.isRequired,
  onLogout: PropTypes.func,
};

export default OnboardingRegionPage;
